import Bloodhound from 'corejs-typeahead';

var $id, $variants, $availability;

const engine = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  identify: product => product.id,
  limit: 100,
  remote: {
    url: '/variants/search?q=%QUERY',
    wildcard: '%QUERY'
  }
});

const dataset = {
  name: 'variants',
  display: 'name_and_description',
  source: engine,
  limit: 50,
  templates: {
    suggestion (variant) {
      return `
        <div class="media">
          <div class="media-left media-middle">
            <img src="${variant.product.thumbnail}" alt="${variant.name_and_description}" width="50">
          </div>
          <div class="media-body media-middle">
            <strong class="text-darker">${variant.name_and_description}</strong>
            <div class="text-muted">
              ${variant.product.stores.map(store => store.name).join(', ')}
            </div>
          </div>
        </div>`;
    }
  }
};

export function init () {
  $id = $('#variant_id');
  $variants = $('#variant');
  $availability = $('#availability');

  /**
  * Typeahead for searching product variants
  */
  $variants.typeahead({
    highlight: true,
    hint: true,
    minLength: 3,
  }, dataset);

  _bindEvents();
}

function _bindEvents () {
  $variants.on('typeahead:select', (e, variant) => {
    $id.val(variant.id);
    $availability.html(variant.availability);
  }).on('typeahead:asyncrequest', (event) => {
    let $variant = $(event.target);

    $variant.closest('.form-group').addClass('has-feedback has-warning');
    $variant.after('<i class="fa fa-spin fa-circle-o-notch"></i>');
  }).on('typeahead:render', (event) => {
    let $variant = $(event.target);

    $variant.closest('.form-group').removeClass('has-feedback has-warning');
    $variant.closest('.form-group').find('.fa').remove();
  });
}
